import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" path="/404" noindex />
      <section className="container-inst flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
        <p className="motif-caps">404</p>
        <h1 className="mt-4 text-3xl font-semibold tracking-[-0.02em]" style={{ color: "var(--text)" }}>This page could not be found.</h1>
        <p className="mt-3 max-w-md text-sm" style={{ color: "var(--muted)" }}>The page you are looking for may have moved or no longer exists.</p>
        <Link to="/" className="btn btn-primary mt-8">Return Home</Link>
      </section>
    </>
  );
}
